import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ling-pending-tag-bar',
  standalone: true,
  imports: [CommonModule, MatButtonModule, TranslateModule],
  templateUrl: './pending-tag-bar.component.html',
  styleUrls: ['./pending-tag-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PendingTagBarComponent {
  @Input() pendingTagId?: string | null;
  @Output() discard = new EventEmitter<void>();
}
